/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_massmol_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make 250 mL of 10 mM Tris (MW 121.14): mass = 0.01 M × 0.25 L × 121.14 = 0.303 g.`)
};

const es_massmol_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparar 250 mL de Tris 10 mM (PM 121.14): masa = 0.01 M × 0.25 L × 121.14 = 0.303 g.`)
};

const de_massmol_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`250 mL von 10 mM Tris herstellen (MW 121,14): Masse = 0,01 M × 0,25 L × 121,14 = 0,303 g.`)
};

const nl_massmol_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak 250 mL van 10 mM Tris (MW 121,14): massa = 0,01 M × 0,25 L × 121,14 = 0,303 g.`)
};

const fr_massmol_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préparer 250 mL de Tris à 10 mM (MM 121,14) : masse = 0,01 M × 0,25 L × 121,14 = 0,303 g.`)
};

const it_massmol_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prepara 250 mL di Tris 10 mM (PM 121,14): massa = 0,01 M × 0,25 L × 121,14 = 0,303 g.`)
};

const pt_br2_massmol_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparar 250 mL de Tris 10 mM (MM 121,14): massa = 0,01 M × 0,25 L × 121,14 = 0,303 g.`)
};

const pt_massmol_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparar 250 mL de Tris 10 mM (MM 121,14): massa = 0,01 M × 0,25 L × 121,14 = 0,303 g.`)
};

const ja_massmol_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`250 mLの10 mM Tris (分子量121.14) を作る: 質量 = 0.01 M × 0.25 L × 121.14 = 0.303 g。`)
};

const zh_massmol_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配制 250 mL 10 mM Tris（分子量 121.14）：质量 = 0.01 M × 0.25 L × 121.14 = 0.303 g。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const massmol_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.massmol_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("massmol_ex2", locale)
	if (locale === "en") return en_massmol_ex2(inputs)
	if (locale === "es") return es_massmol_ex2(inputs)
	if (locale === "de") return de_massmol_ex2(inputs)
	if (locale === "nl") return nl_massmol_ex2(inputs)
	if (locale === "fr") return fr_massmol_ex2(inputs)
	if (locale === "it") return it_massmol_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_massmol_ex2(inputs)
	if (locale === "pt") return pt_massmol_ex2(inputs)
	if (locale === "ja") return ja_massmol_ex2(inputs)
	return zh_massmol_ex2(inputs)
};